module.exports = __webpack_public_path__ + "static/media/features-build.9bdc16f7.png";